import { Loader2 } from "lucide-react";

import { cx } from "./cx";

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cx("size-5 animate-spin text-fg-subtle", className)} aria-label="Loading" />;
}

export function FullPageSpinner() {
  return (
    <div className="flex h-full min-h-60 items-center justify-center">
      <Spinner className="size-6" />
    </div>
  );
}
